import React from "react";
import { IconProps } from "../icon";

export const ArrowsUpIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7 20V4m0 0L3 8m4-4l4 4m6 12V9m0 0l-4 4m4-4l4 4"
    />
  </svg>
);
